<template>
  <transition
    @enter="enter"
    @leave="leave"
    mode="out-in">
    <router-view/>
  </transition>
</template>

<script>
  import {TweenMax, Power1} from 'gsap/TweenMax'

  export default {
    computed: {
      directionEnter () {
        if (this.$store.getters.getNavDirection === 'back') return -50
        else return 50
      },
      directionLeave () {
        if (this.$store.getters.getNavDirection === 'back') return 50
        else return -50
      }
    },
    methods: {
      enter (el, done) {
        TweenMax.from(el, 0.15, {x: this.directionEnter, autoAlpha: 0, ease: Power1.easeOut, onComplete: done})
      },
      leave (el, done) {
        TweenMax.to(el, 0.15, {x: this.directionLeave, autoAlpha: 0, ease: Power1.easeIn, onComplete: done})
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Wrapper.vue?5495cc6a